/* --------------------------------------------------------------------------
	YouTube Replace
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	var $Container, $Player, VideoId, VideoTitle, $Wrapper, Player;

	function init() {
		if (!$('.js-youtube-video').length) {
			return;
		}

		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		$('.js-youtube-video').each(function () {
			$(this).find('.js-youtube-button').on('click', onButtonClick);
		});

		if ($('.js-expand-dialog').length) {
			$('.js-expand-dialog-close').on('click', onDialogCloseClick);
		}

		if ($('.js-express-tabs').length) {
			$('.js-express-tab-trigger').on('click', onTabClick);
		}
	}

	function onButtonClick() {
		$Container = $(this).closest('.js-youtube-video');
		$Player = $Container.find('.js-youtube-player');
		VideoId = $Container.data('video');
		VideoTitle = '- ' + $Container.data('title');
		$Wrapper = $Container.closest('.js-youtube-video-wrapper');

		window.YT.ready(function () {
			onYouTubeIframeAPIReady();
		});
	}

	function onYouTubeIframeAPIReady() {
		Player = new YT.Player($Player[0], {
			height: '390',
			width: '640',
			videoId: VideoId,
			title: VideoTitle,
			playerVars: {
				rel: 0,
				playsinline: 1,
				autoplay: 1,
				origin: encodeURIComponent(window.location.protocol + '//' + window.location.hostname)
			},
			events: {
				onReady: onPlayerReady
			}
		});
	}

	function onPlayerReady(event) {
		$Wrapper.addClass('ready');
		event.target.playVideo();
	}

	function onDialogCloseClick() {
		Player.pauseVideo();
	}

	function onTabClick() {
		Player.pauseVideo();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
